<!-- Page de validation d'une commande

    Affiche un récap du panier (semblable à la page cart)
-->

<div class="globalContainer">
    <div id="cart">
        <div id="cartLayer" *ngIf="displayDialog">
            <div id="cartDialogLike" *ngIf="displayDialog">
                <h1 style="margin-bottom: 30px;">Paiement confirmé !</h1>
    
                <div class="thanksContainer">
                    <div id="animationContainer">
                        <svg
                            id="successAnimation"
                            class="animated"
                            xmlns="http://www.w3.org/2000/svg"
                            width="70"
                            height="70"
                            viewBox="0 0 70 70"
                        >
                            <path
                                id="successAnimationResult"
                                fill="#D8D8D8"
                                d="M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z"
                            />
                            <circle
                                id="successAnimationCircle"
                                cx="35"
                                cy="35"
                                r="24"
                                stroke="#979797"
                                stroke-width="2"
                                stroke-linecap="round"
                                fill="transparent"
                            />
                            <polyline
                                id="successAnimationCheck"
                                stroke="#979797"
                                stroke-width="2"
                                points="23 34 34 43 47 27"
                                fill="transparent"
                            />
                        </svg>
                    </div>
                    <p class="itemTitle">Merci d'avoir passé commande sur Wanview !</p>
                </div>
        
                <p class="itemTitle">
                    Votre campagne est désormais disponible dans 'Ecrans'
                </p>
        
                <button
                    class="centeredBtn"
                    style="margin-top: 20px"
                    mat-raised-button
                    color="primary"
                    (click)="displayDialog = false"
                >
                    Voir le récapitulatif de ma commande
                </button>
            </div>
        </div>
        
        
        @if (orderId && orderRecap && !isOrderRecapLoading) {

        <div class="recapOrder">
            <h1>Récapitulatif de la commande</h1>
            <div class="campaign">
                <!-- Nom de la campagne -->
                <article class="infoItem">
                    <p class="itemTitle">Nom de la campagne</p>
                    <p class="itemValue">{{ orderRecap.cn[0].cn }}</p>
                </article>

                <!-- Dates de la campagne -->
                <article class="infoItem">
                    <p class="itemTitle">Dates</p>
                    <p class="itemValue">
                        Du
                        <strong>{{
                            orderRecap.cn[0].sd | date : "dd/MM/yyyy"
                        }}</strong>
                        au
                        <strong>{{
                            orderRecap.cn[0].ed | date : "dd/MM/yyyy"
                        }}</strong>
                    </p>
                </article>

                <!-- Face par groupe de parc écran -->
                <ng-container *ngFor="let sp of orderRecap.sp">
                    
                    <div  class="screenGroup" *ngIf="sp.i != null">
                        <div style="min-height: 50px" class="screenGroupHeader">
                            <!-- Icon Outdoor -->
                            <mat-icon
                                *ngIf="sp.i !== 14"
                                style="height: 40px"
                                alt="Ecran Indoor"
                                class="screenTypeImg"
                                svgIcon="store-outdoor"
                            ></mat-icon>
                            <!-- Icon Indoor -->
                            <mat-icon
                                *ngIf="sp.i === 14"
                                style="height: 40px"
                                alt="Ecran Indoor"
                                class="screenTypeImg"
                                svgIcon="store-indoor"
                            ></mat-icon>
                            <span class="screenParkName">
                                <span class="outdoor" *ngIf="sp.i !== 14"
                                    >Ecran Géant extérieur</span
                                >
                                <span class="indoor" *ngIf="sp.i === 14"
                                    >Ecran Intérieur</span
                                >
                                <br />
                                <span class="screenCount"
                                    >{{ sp.fAs.length }} Ecran<ng-container
                                        *ngIf="sp.fAs.length > 1"
                                        >s</ng-container
                                    ></span
                                >
                            </span>
                            <div class="screenParkPrice">
                                <span>{{ sp.ht | currency: 'EUR' : 'symbol' : undefined : 'fr' }}</span>
                                <br />
                                <span
                                    style="
                                        font-size: 13px;
                                        font-weight: 500;
                                        font-style: italic;
                                    "
                                    >{{ sp.tj | currency: 'EUR' : 'symbol' : undefined : 'fr' }} x {{ orderRecap.da }} jrs</span
                                >
                            </div>
                        </div>
                        <!-- Go For FaceList -->
                        <ng-container
                            *ngFor="let face of sp.fAs; let first = first"
                        >
                            <hr *ngIf="!first && !face.hide" class="screenTileHR" />

                            <div *ngIf="!face.hide" class="screenTile">
                                <img
                                    class="screenImg"
                                    alt="Miniature de l'écran"
                                    *ngIf="
                                        face.ts && face.ts != null && face.ts != ''
                                    "
                                    src="{{ baseUrl }}/file/getFile/{{ face.ts }}/{{
                                        face.ts
                                    }}"
                                />
                                <div>
                                    <p class="screenAddress">
                                        {{ face.a }}, {{ face.zc }} {{ face.c }}
                                    </p>
                                    <p class="screenCode">{{ face.sc }}</p>
                                </div>
                                <p class="faceDaylyPrice">{{ face.ht | currency: 'EUR' : 'symbol' : undefined : 'fr'}} / jour</p>
                            </div>
                        </ng-container>
                        <div *ngIf="sp.fAs.length > 5" class="screenTile">
                            <p
                                class="screenCode"
                                *ngIf="!sp.expend"
                                class="expend"
                                (click)="expendSP(sp)"
                            >
                                Voir plus
                            </p>
                            <p
                                class="screenCode"
                                *ngIf="sp.expend"
                                class="expend"
                                (click)="minusSP(sp)"
                            >
                                Voir moins
                            </p>
                        </div>
                    </div>
                </ng-container>

                <!-- Vente de spot -->
                <div class="spotGroup" *ngIf="orderRecap.so != null">
                    <div style="min-height: 50px; margin-bottom: 20px;" *ngFor="let spot of orderRecap.so" class="screenGroupHeader">
                        
                        <mat-icon
                            style="height: 40px"
                            class="material-icons screenTypeImg"
                        >play_circle_outline</mat-icon>
                       
                        <span class="screenParkName">
                            <span class="outdoor" *ngIf="spot.t == 0" 
                                >Création de spot</span
                            >
                            <span class="outdoor" *ngIf="spot.t == 1" 
                                >Création de template</span
                            >
                            
                        </span>
                        <div class="screenParkPrice">
                            
                            <span>{{spot.ht}}€</span>
                            <span
                                style="
                                display: block;
                                    font-size: 13px;
                                    font-weight: 500;
                                    font-style: italic;
                                "
                                >{{
                                    spot.n
                                }} x {{spot.ht / spot.n}}€
                               </span
                            >
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div class="endCartContainer">
            <article class="priceItem">
                <span class="itemTitle">Total HT</span>
                <span class="itemValue">{{ orderRecap.ht | currency: 'EUR' : 'symbol' : undefined : 'fr'}}</span>
            </article>
            <hr class="priceItemHr" />
            <article class="priceItem">
                <span class="itemTitle">Total TVA</span>
                <span class="itemValue">{{ orderRecap.ta | currency: 'EUR' : 'symbol' : undefined : 'fr'}}</span>
            </article>
            <hr class="priceItemHr" />
            <article class="priceItem totalPriceItem">
                <span class="itemTitle">Total TTC</span>
                <span class="itemValue">{{ orderRecap.tt | currency: 'EUR' : 'symbol' : undefined : 'fr'}}</span>
            </article>
        </div>
        }@else if(orderId != null && orderRecap == null &&
        !isOrderRecapLoading){
        <div class="recapOrder">
            <p class="itemTitle" style="color: #ffcf55">
                Erreur lors du chargement du récapitulatif de votre commande
            </p>
            <button
                class="centeredBtn"
                mat-stroked-button
                color="primary"
                (click)="loadOrderRecap()"
            >
                <mat-icon>refresh</mat-icon>Réessayer
            </button>
        </div>
        }@else if ( isOrderRecapLoading) {
        <div class="loadingCart">
            <i>Chargement du récapitulatif de votre commande ...</i>
            <mat-spinner [diameter]="50"></mat-spinner>
        </div>
        }

        <button
            class="centeredBtn"
            style="margin-top: 20px"
            mat-raised-button
            color="primary"
            (click)="goToPark()"
        >
            Voir mes écrans dans Wanview
        </button>
    </div>
</div>
